module.exports = new __parcel__URL__("gape_genesis_empty.56f7c9d9.png").toString();